
import { defineComponent, ref, computed } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ModalDeleteAndReason from "@/components/modals/wizards/ModalDeleteAndReason.vue";
import RescoreDrawer from "@/components/customers/RescoreDrawer.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance"
import { hideModal } from "@/core/helpers/dom";
import { filterScholarshipOptions } from "@/core/helpers/profileAccess";
import Permission from "@/core/config/Permission";
import { saveAs } from 'file-saver';
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import moment from "moment";
import { emitter } from '@/main';
import { useRoute,useRouter } from "vue-router";
import { statusTagDefault } from "./ProfileDetailInfor.vue";
import { loadMajorsOnce } from "./HoSoQuickDrawer.vue";

interface DataAdmission {
  date: string;
  code: string;
  method: string;
  id: string;
  action: boolean;
  isActive: boolean;
  source: string;
  phase: string;
  updatedAt?: string;
  status: {
      label: string;
      state: string;
      value: string;
  },
  majors: [{
    name: string,
    priority: string,
  }]
}
export default defineComponent({
  name: "statement",
  data() {
    return {
      isEdit: false,
      tempRecord: {} as any,
      dataAdmissionRegister: {},
      drawerVisible: false,
      drawerRow: null as any,
      drawerDetail: null as any,
      drawerLoading: false,
      arproMajorName: null as any,
      editingStatusId: null as any,
      // Modal Đăng ký học bổng
      scholarshipCatalog: [] as any,
      regSchRecord: null as any,
      regSchId: null as any,
      regSchMajorId: null as any, // ngành nhận HB — mặc định NV1 của hồ sơ
      regSchSaving: false,
      regSchError: '',
    }
  },
  emits: ["callbackFunction", "reload"],
  props: {
    cardClasses: String,
    dataAdmission: { type:  Array as () => Array<DataAdmission>, required: true },
    highschoolGraduation: String,
    orderNumber: String,
    priorityScore: Number,
    dataCustomer: {
    type: Object,
    required: false, // hoặc có thể bỏ dòng này vì mặc định là false
  },
  },
  components: {
    Datatable,
    ModalDeleteAndReason,
    RescoreDrawer,
  },
  methods: {
    //THU HỒI QĐ trúng tuyển (kebab tab Hồ sơ ĐKXT — cùng luồng với DS trúng tuyển): bắt buộc lý do;
    //winner giữ vết revoked, hồ sơ về TRƯỚC thẩm định (mở khóa sửa). SV đã khởi tạo nhập học -> server chặn.
    async revokeWinner(record) {
      const { value: reason, isConfirmed } = await Swal.fire({
        title: 'Thu hồi QĐ trúng tuyển',
        html: `<div class="text-start fs-6 mb-2">Hồ sơ <b>${record.code}</b> · QĐ số <b>${record.winnerDecisionCode || ''}</b></div>` +
          `<div class="text-start fs-7 text-muted mb-1">Winner được GIỮ LẠI làm vết (badge "Đã thu hồi QĐ" ở Danh sách trúng tuyển), hồ sơ về TRƯỚC thẩm định (mở khóa để sửa dữ liệu — sửa xong thẩm định + xét lại). Không hoàn tác được từ màn này.</div>`,
        input: 'textarea',
        inputPlaceholder: 'Lý do thu hồi (bắt buộc) — vd: điểm xét sai, hậu kiểm không đạt...',
        inputValidator: (v) => (!v || !v.trim() ? 'Vui lòng nhập lý do thu hồi' : undefined),
        icon: 'warning', showCancelButton: true, buttonsStyling: false,
        confirmButtonText: 'Thu hồi', cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-light' },
      })
      if (!isConfirmed) return
      await axios.post('/admission/passed/revoke', { ids: [record.winnerId], reason: reason.trim() })
        .then(({ data }) => {
          const r = (data.results && data.results[0]) || {}
          Swal.fire({
            text: r.chiTiet || (data.revoked ? 'Đã thu hồi QĐ trúng tuyển.' : 'Không thu hồi được.'),
            icon: data.revoked ? 'success' : 'warning',
            buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
          })
          this.$emit('reload')
        })
        .catch(({ response }) => {
          Swal.fire({ text: response?.data?.errorMessage || 'Thu hồi thất bại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
        })
    },
    //Cập nhật điểm hồ sơ đã trúng tuyển (lệch Bộ) — truyền adreg id, BE tự tìm winner đang hiệu lực
    openRescore(record) {
      (this.$refs.rescoreDrawer as any)?.open(record.id)
    },
    //CẤP SỐ QĐ trúng tuyển cho hồ sơ trúng TẠM (đủ bộ với "Xét trúng tuyển" — khỏi sang trang Kết quả xét tuyển sinh)
    async confirmDecision(record) {
      const today = new Date().toISOString().slice(0, 10)
      const { value, isConfirmed } = await Swal.fire({
        title: 'Cấp QĐ trúng tuyển',
        html: `<div class="text-start fs-7 text-gray-700 mb-3">Hồ sơ <b>${record.code}</b> — cấp Số/Ngày QĐ để thành trúng tuyển <b>CHÍNH THỨC</b>.</div>` +
          `<div class="text-start mb-2"><label class="form-label fw-bolder fs-8 mb-1">Số QĐ <span class="text-danger">*</span></label>` +
          `<input id="swal_qd_code" class="form-control form-control-sm" placeholder="vd: 123/QĐ-UMT" /></div>` +
          `<div class="text-start"><label class="form-label fw-bolder fs-8 mb-1">Ngày QĐ <span class="text-danger">*</span></label>` +
          `<input id="swal_qd_date" type="date" class="form-control form-control-sm" value="${today}" /></div>`,
        focusConfirm: false, showCancelButton: true, buttonsStyling: false,
        confirmButtonText: 'Cấp QĐ', cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-primary order-2', cancelButton: 'btn btn-light order-1' },
        preConfirm: () => {
          const code = (document.getElementById('swal_qd_code') as HTMLInputElement)?.value?.trim()
          const date = (document.getElementById('swal_qd_date') as HTMLInputElement)?.value
          if (!code || !date) { Swal.showValidationMessage('Vui lòng nhập đủ Số QĐ và Ngày QĐ'); return false }
          return { code, date }
        },
      })
      if (!isConfirmed || !value) return
      await axios.post('/admission/passed/confirmsingle', { id: record.id, decisionCode: value.code, decisionDate: value.date })
        .then(({ data }) => {
          Swal.fire({
            html: `Hồ sơ <b>${data.profileCode}</b> trúng tuyển <b>CHÍNH THỨC</b> — QĐ <b>${data.decisionCode}</b>.`,
            icon: 'success', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
          })
          this.$emit('reload')
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response?.data?.errorMessage || response?.data?.message || 'Cấp QĐ thất bại.',
            icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
          })
        })
    },
    callModalDelete(record) {
      this.tempRecord = record
      // Chặn xóa hồ sơ đã trúng tuyển
      if (record && record.status && record.status.value === 'passed') {
        Swal.fire({
          text: 'Không thể xóa hồ sơ này vì đã trúng tuyển. Vui lòng hủy kết quả trúng tuyển trước.',
          icon: 'warning',
          buttonsStyling: false,
          confirmButtonText: 'Đã hiểu',
          customClass: { confirmButton: 'btn btn-primary' },
        })
        return
      }
      this.callFunctionModal?.showModal()
    },
    async submitComment() {
      if (this.comment_profile == '') {
        return;
      }
      let dataComment = {
        "idUser": this.user()?.id,
        "idStudent": this.route.params.id,
        "comment": `Đã chuyển hồ sơ ${this.tempRecord.code} thành Không hợp lệ. Lý do: `+this.comment_profile
      }
      await axios.post(`/admission/comment`,dataComment)
      .then(( {data} ) => {
        this.comment_profile = ''
        emitter.emit("addComment", data);
        this.callApiChangeStatus()
        hideModal(this.addAuthRejectedModalRef)
      })
      .catch(({ response }) => {
      });
    },
    async downloadAdmission(record) {
      await axios.get(`/admission/register/download/${record.id}`,
        {responseType: 'arraybuffer', }) //arraybuffer, blob
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          })
          const url = URL.createObjectURL(blob)
          let cd = response.headers['content-disposition'].split('"')
          const fileName = cd.length > 1 ? cd[1] : 'ho-so.zip'
          saveAs(url, fileName)
        }).catch(err=> {
        })
    },
    adDetail() {
      const d = this.drawerDetail && this.drawerDetail.adDetails
      if (!d) return null
      return Array.isArray(d) ? (d[0] || null) : d
    },
    scoreMethodLabel() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any)
      const names = { 1: 'Học bạ', 2: 'ĐGNL', 3: 'Ưu tiên xét tuyển', 4: 'Điểm thi THPT', 5: 'Tương đương (SAT/ACT/TC01)', 6: 'V-SAT', 9: 'Liên thông' }
      if (!names[reg.idAdMethod]) return null
      return this.methodLabelFull()
    },
    // Học bạ không hợp lệ nếu biến thể != 9CR (chính sách UMT 2026)
    hocbaVariantInvalid() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any)
      if (reg.idAdMethod != 1) return false
      const d = this.adDetail()
      const t = d && d.admissiontype ? String(d.admissiontype).trim() : ''
      return t !== '9CR'
    },
    // Nhãn PT kèm biến thể Học bạ (admissiontype: THM/3YS/9CR; rỗng -> N/A)
    methodLabelFull() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || null
      if (!reg) return (this.drawerRow && this.drawerRow.method) || '—'
      const names = { 1: 'Học bạ', 2: 'ĐGNL', 3: 'Ưu tiên xét tuyển', 4: 'Điểm thi THPT', 5: 'Tương đương (SAT/ACT/TC01)', 6: 'V-SAT', 9: 'Liên thông' }
      const base = names[reg.idAdMethod] || (this.drawerRow && this.drawerRow.method) || '—'
      if (reg.idAdMethod == 1) {
        const d = this.adDetail()
        const t = d && d.admissiontype ? String(d.admissiontype).trim() : ''
        return `${base} (${t || 'N/A'})`
      }
      return base
    },
    // Gom điểm theo đúng cách lưu của TỪNG phương thức (quét từ model BE) → [{title, rows:[{label,value}], wide?}]
    scoreGroups() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any)
      const m = reg.idAdMethod
      const d = this.adDetail()
      const groups = [] as any[]
      const has = (v) => !(v === null || v === undefined || v === '')
      const num = (v) => (has(v) ? v : '—')
      const flat = (title, pairs, wide = false) => {
        if (!d) return
        const rows = pairs.filter((p) => has(d[p[0]])).map((p) => ({ label: p[1], value: d[p[0]] }))
        if (rows.length) groups.push({ title, rows, wide: !!wide })
      }

      // PT9 liên thông: không có bảng điểm → GPA từ _arpros
      if (m == 9) {
        const a = reg._arpros || {}
        const rows = [['gpa', 'GPA'], ['gpafor', 'Thang quy đổi']]
          .filter((p) => has(a[p[0]])).map((p) => ({ label: p[1], value: a[p[0]] }))
        if (rows.length) groups.push({ title: 'Điểm liên thông', rows, wide: false })
        return groups
      }
      if (!d) return groups

      if (m == 1) {
        // Học bạ: 9CR (tổ hợp 3 môn × 3 năm) | THM (điểm môn L12) | 3YS (cả năm L10/11/12)
        const sps = [d.subjectpoint1, d.subjectpoint2, d.subjectpoint3]
        const has9CR = sps.some((s) => Array.isArray(s) && s.length)
        if (has9CR) {
          sps.forEach((arr, i) => {
            if (!Array.isArray(arr) || !arr.length) return
            // Bỏ tổ hợp ưu tiên không chọn (không nhập điểm)
            const picked = arr.some((it) => {
              const dt = (it && it.data) || {}
              return has(dt.point0) || has(dt.point1) || has(dt.point2)
            })
            if (!picked) return
            const rows = arr.map((it) => {
              const dt = (it && it.data) || {}
              const subj = (it && (it.label || it.subject || it.type)) || 'Môn'
              return { label: subj, value: `${num(dt.point0)} / ${num(dt.point1)} / ${num(dt.point2)}` }
            })
            if (rows.length) groups.push({ title: `Tổ hợp ưu tiên ${i + 1} — L10 / L11 / L12`, rows, wide: true })
          })
        } else {
          flat('Điểm TB môn lớp 12', [
            ['class12AverageMathScore', 'Toán'], ['class12AverageLiteratureScore', 'Ngữ văn'],
            ['class12AverageEnglishScore', 'Tiếng Anh'], ['class12AveragePhysicsScore', 'Vật lý'],
            ['class12AverageChemistryScore', 'Hóa học'], ['class12AverageBiologyScore', 'Sinh học'],
            ['class12AverageHistoryScore', 'Lịch sử'], ['class12AverageGeographyScore', 'Địa lý'],
            ['class12AverageFrenchScore', 'Tiếng Pháp'], ['class12AverageCivicEducationScore', 'GDCD'],
            ['class12AverageInformationTechnologyScore', 'Tin học'], ['class12AverageEconomicsAndLawEducationScore', 'GD KT&PL'],
            ['class12AverageArtScore', 'Năng khiếu'],
          ])
          flat('Điểm TB cả năm', [
            ['class10TotalScore', 'Lớp 10'], ['class11TotalScore', 'Lớp 11'],
            ['class12TotalScore', 'Lớp 12'], ['class12Semester1Score', 'Lớp 12 (HK1)'],
          ])
        }
      } else if (m == 2) {
        flat('Điểm ĐGNL', [['totalScore', 'Tổng điểm (thang 1200)'], ['nlqgScore', 'Điểm quy đổi (thang 30)']])
      } else if (m == 3) {
        flat('Chứng chỉ', [['ieltsScore', 'IELTS'], ['toeflScore', 'TOEFL iBT'], ['toeicScore', 'TOEIC'], ['satScore', 'SAT']])
        const conds = [
          ['isCollegeDiploma', 'Có bằng CĐ'], ['isInternationalCert', 'Chứng chỉ quốc tế'],
          ['isNationalAward', 'Giải quốc gia'], ['isGoodInHighschool', 'HS giỏi THPT'],
          ['isAthleteCertOrPreMaster', 'VĐV / Dự bị ĐH'],
        ].filter((p) => !!d[p[0]]).map((p) => ({ label: p[1], value: '✓' }))
        if (conds.length) groups.push({ title: 'Diện đủ điều kiện', rows: conds, wide: false })
      } else if (m == 4) {
        flat('Điểm thi THPT', [
          ['mathScore', 'Toán'], ['literatureScore', 'Ngữ văn'], ['englishScore', 'Tiếng Anh'],
          ['physicsScore', 'Vật lý'], ['chemistryScore', 'Hóa học'], ['biologyScore', 'Sinh học'],
          ['historyScore', 'Lịch sử'], ['geographyScore', 'Địa lý'], ['frenchScore', 'Tiếng Pháp'],
          ['civicEducationScore', 'GDCD'], ['informationTechnologyScore', 'Tin học'],
          ['economicsAndLawEducationScore', 'GD KT&PL'], ['artScore', 'Năng khiếu'],
        ])
      } else if (m == 5) {
        if (has(d.formOfMethod)) groups.push({ title: '', rows: [{ label: 'Tiêu chí', value: d.formOfMethod }], wide: false })
        flat('Điểm chuẩn hóa', [['sat', 'SAT'], ['actScore', 'ACT'], ['tc01AverageGrade12', 'TB lớp 12 (TC01)']])
        flat('Điểm THPT (TC01)', [
          ['mathTHPT', 'Toán'], ['literatureTHPT', 'Ngữ văn'], ['englishTHPT', 'Tiếng Anh'],
          ['physicsTHPT', 'Vật lý'], ['chemistryTHPT', 'Hóa học'], ['biologicalTHPT', 'Sinh học'],
          ['historyTHPT', 'Lịch sử'], ['geographyTHPT', 'Địa lý'], ['frenchTHPT', 'Tiếng Pháp'],
          ['civicEducationTHPT', 'GDCD'], ['informationTechnologyTHPT', 'Tin học'],
          ['economicsAndLawEducationTHPT', 'GD KT&PL'], ['artTHPT', 'Năng khiếu'],
        ])
      } else if (m == 6) {
        flat('Điểm V-SAT', [
          ['mathScore', 'Toán'], ['literatureScore', 'Ngữ văn'], ['englishScore', 'Tiếng Anh'],
          ['physicsScore', 'Vật lý'], ['chemistryScore', 'Hóa học'], ['biologyScore', 'Sinh học'],
          ['historyScore', 'Lịch sử'], ['geographyScore', 'Địa lý'], ['normalizedScore', 'Điểm quy đổi (thang 30)'],
        ])
      } else if (d) {
        // Phương thức khác: hiện mọi field số đã nhập
        const rows = Object.keys(d)
          .filter((k) => /score|point|grade|sat|act|gpa/i.test(k) && typeof d[k] !== 'object' && has(d[k]))
          .map((k) => ({ label: k, value: d[k] }))
        if (rows.length) groups.push({ title: 'Điểm', rows, wide: false })
      }
      return groups
    },
    artVal(key) {
      const a = this.drawerDetail && this.drawerDetail.adRegister && this.drawerDetail.adRegister._arpros
      const v = a ? a[key] : null
      return (v === null || v === undefined || v === '') ? '—' : v
    },
    sfMappedFields() {
      const c = (this.dataCustomer || {}) as any
      const reg = ((this.drawerDetail && this.drawerDetail.adRegister) || {}) as any
      const isVerified = this.drawerRow && this.drawerRow.status && this.drawerRow.status.value === 'verified'
      const gender = (c.gender === true || c.gender === 1 || c.gender === '1') ? 'Male'
        : (c.gender === false || c.gender === 0 || c.gender === '0') ? 'Female' : null
      // Năm tuyển sinh/tốt nghiệp: BE đẩy theo ADMISSION_YEAR (env mùa tuyển sinh) — suy ra theo năm tạo hồ sơ.
      // createdAt có thể là ISO hoặc chuỗi "DD/MM/YYYY ..." đã format → rút 4 chữ số năm, tránh moment cảnh báo deprecation.
      const yearFrom = (v) => { if (!v) return null; const mm = String(v).match(/\d{4}/); return mm ? mm[0] : null }
      const admYear = yearFrom(reg.createdAt) || yearFrom(c.createdAt) || yearFrom(this.drawerRow && this.drawerRow.date)
      // UTM tracking (đẩy lên Lead) — utmobj có thể là object hoặc chuỗi JSON
      let utm = c.utmobj
      if (typeof utm === 'string') { try { utm = JSON.parse(utm) } catch (e) { utm = {} } }
      utm = utm || {}
      const arr = [
        { label: 'Họ tên', sf: 'LastName', value: c.fullName },
        { label: 'SĐT', sf: 'MobilePhone', value: c.phone },
        { label: 'Email', sf: 'Email', value: c.email },
        { label: 'CCCD', sf: 'CMND_CCCD__c', value: c.idCard },
        { label: 'Loại', sf: 'Enquiry_Type__c', value: 'Student' },
        { label: 'Giới tính', sf: 'Gender__c', value: gender },
        { label: 'Điểm ưu tiên', sf: 'Priority_Score__c', value: (c.priorityScore || c.priorityScore === 0) ? c.priorityScore : null },
        { label: 'Đối tượng ưu tiên', sf: 'Priority_Category_i_t_ng_u_ti_n__c', value: c.priorityObject },
        { label: 'Khu vực ưu tiên', sf: 'Priority_Region_Khu_v_c_u_ti_n__c', value: c.priorityArea },
        { label: 'Thường trú', sf: 'Permanent_Address__c', value: c.prAddress },
        { label: 'Mã hồ sơ', sf: 'Application_ID__c', value: reg.profileCode },
        { label: 'Ngày nộp', sf: 'Admission_date__c', value: this.drawerRow && this.drawerRow.date },
        { label: 'StageName', sf: 'StageName', value: isVerified ? 'Scholarship Interview' : null },
        { label: 'Trường L12', sf: 'Current_School__c', value: c['class12School.name'] || c.class12SchoolName },
        { label: 'Tỉnh thường trú', sf: 'New_Province__c', value: c.newPrProvinceName },
        { label: 'UTM Source', sf: 'utm_source__c', value: utm.utm_source },
        { label: 'UTM Medium', sf: 'utm_medium__c', value: utm.utm_medium },
        { label: 'UTM Campaign', sf: 'utm_campaign__c', value: utm.utm_campaign },
        // Field gắn cứng (hằng / suy ra) — vẫn map lên SF
        { label: 'Nguồn lead', sf: 'LeadSource', value: 'Admission Portal', fixed: true },
        { label: 'Năm tuyển sinh', sf: 'Admission_Year__c', value: admYear, fixed: true },
        { label: 'Năm tốt nghiệp', sf: 'Graduation_Year__c', value: admYear, fixed: true },
        { label: 'Đã nộp HS', sf: 'Application_Submitted__c', value: isVerified ? 'true' : '(true khi verified)', fixed: true },
        { label: 'Lưu trữ', sf: 'Is_Archived__c', value: 'false', fixed: true },
      ]
      return arr.filter(f => f.value !== null && f.value !== undefined && f.value !== '')
    },
    async openQuickView(record) {
      this.drawerRow = record
      this.drawerDetail = null
      this.arproMajorName = null
      this.drawerLoading = true
      this.drawerVisible = true
      try {
        const { data } = await axios.get(`/admission/register/${record.id}`)
        if (data?.adRegister?.updatedAt) {
          data.adRegister.updatedAtText = moment(data.adRegister.updatedAt).format('DD/MM/YYYY HH:mm')
        }
        this.drawerDetail = data
        // Hồ sơ LIÊN THÔNG: resolve TÊN ngành từ mã (arpros.registeredmajor chỉ lưu mã)
        const _arp = data?.adRegister?._arpros
        if (_arp && _arp.registeredmajor) {
          const majors = await loadMajorsOnce()
          const m = (majors || []).find((x: any) => x.code == _arp.registeredmajor)
          this.arproMajorName = m ? m.name : null
        }
      } catch (e) {
        // im lặng — vẫn hiển thị tóm tắt từ dữ liệu hàng
      }
      this.drawerLoading = false
    },
    // Ngành của hồ sơ liên thông (adMajors rỗng) — đồng bộ logic với HoSoQuickDrawer
    arproMajor() {
      const reg = ((this.drawerDetail && this.drawerDetail.adRegister) || {}) as any
      const a = reg._arpros
      if (!a || !a.registeredmajor) return null
      return {
        name: this.arproMajorName || a.registeredmajor,
        code: a.registeredmajor,
        averageScore: a.admissionscores ? a.admissionscores.averageScore : null,
      }
    },
    sendMail(record) {
      // Hộp thoại xác nhận CÓ INPUT EMAIL (prefill email ứng viên — sửa được nếu email sai/gửi nơi khác).
      // Trước đây gửi thẳng + báo thành công GIẢ sau 500ms bất kể kết quả.
      const defaultEmail = (this.dataCustomer && this.dataCustomer.email) || ''
      Swal.fire({
        title: 'Gửi mail phiếu ĐKXT',
        html: `<div class="text-start fs-6 text-gray-700 mb-1">Gửi phiếu đăng ký xét tuyển <b>${record.code}</b> (kèm PDF) tới email:</div>`,
        input: 'email',
        inputValue: defaultEmail,
        inputPlaceholder: 'ten@example.com',
        validationMessage: 'Email không hợp lệ',
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: 'Gửi mail',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-primary order-2',
          cancelButton: 'btn btn-light order-1',
          input: 'form-control',
        },
      }).then(async (res: any) => {
        if (!res.isConfirmed) return
        const email = String(res.value || '').trim()
        this.popupLoading()
        await axios.post(`/admission/mail/send/`, { idAdReg: record.id, overrideEmail: email })
          .then(() => {
            record.sentMail = true
            Swal.fire({
              html: `Đã gửi phiếu ĐKXT tới <b>${email}</b>!`,
              icon: 'success',
              buttonsStyling: false,
              timer: 2500,
              timerProgressBar: true,
              showConfirmButton: false,
            })
          })
          .catch(({ response }) => {
            Swal.fire({
              text: response?.data?.errorMessage || response?.data?.message || 'Gửi mail thất bại, vui lòng thử lại.',
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Đóng',
              customClass: { confirmButton: 'btn btn-primary' },
            })
          })
      })
    },
    popupLoading() {
       Swal.fire({
        html:"<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      }).then(() => {
        //
      });
    },
    async getPdf(record) {
      this.popupLoading()
      // Backend LUÔN render lại phiếu từ dữ liệu hiện tại (Puppeteer) -> có thể mất ~15-20s (đã có loading).
      await axios.get(`/admission/pdf/${record.code}`)
      .then(( {data} ) => {
        Swal.close()
        window.open(data.path,'_blank');
      })
      .catch(({ response }) => {
        // PHẢI đóng popup loading khi lỗi — không thì spinner quay vô hạn
        Swal.close()
        Swal.fire({
          text: "Không lấy được phiếu PDF. Vui lòng thử lại sau.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Đã hiểu",
          customClass: { confirmButton: "btn btn-primary" },
        });
      });
    },
    canEditStatus(record) {
      // Gác quyền EDIT_STATUS + khoá khi đã thẩm định (badge vẫn hiện để XEM, chỉ chặn click đổi)
      return !record.isAppraised && this.checkPermission([Permission.ADMISSION_REGISTER_EDIT_STATUS, Permission.ADMISSION_REGISTER])
    },
    editUpdateStatus(record) {
      this.editingStatusId = record.id
      this.statusRecord = record.status.value
    },
    async updateStatusAdmission(record) {
      this.tempRecord = record
      if(!this.highschoolGraduation && this.statusRecord == 'verified') {
         Swal.fire({
            text: "Vui lòng kiểm tra lại điều kiện tốt nghiệp THPT của ứng viên này!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Trở lại",
            customClass: {
                confirmButton: "btn btn-primary",
            },
        }).then(() => {
            //hideModal(addCustomerModalRef.value);
        });   
        this.$emit('callbackFunction',true)
        return
      }
      
      else {
        this.$emit('callbackFunction',false)
      }
      // Chặn sớm: hồ sơ thường (idAdMethod != 9) chưa chọn ngành thì không cho "Đã xác thực".
      // (BE cũng chặn; đây để báo sớm, đỡ phải bấm xác nhận đẩy SF.) Chỉ chặn khi CHẮC CHẮN có dữ liệu majors (tránh false-block).
      if(this.statusRecord == 'verified' && this.tempRecord.idAdMethod != 9
         && Array.isArray(this.tempRecord.majors)
         && !this.tempRecord.majors.some(m => m && (m.name || (m.major && m.major.name)))) {
        Swal.fire({
          title: 'Chưa chọn ngành',
          html: 'Hồ sơ này <b>chưa chọn ngành</b> (hoặc ngành đã bị xoá) nên không thể chuyển sang <b>Đã xác thực</b>.<br>Vui lòng chọn lại ngành đăng ký trước.',
          icon: 'warning',
          buttonsStyling: false,
          confirmButtonText: 'Đã hiểu',
          customClass: { confirmButton: 'btn btn-primary' },
        })
        this.editingStatusId = null
        return
      }
      if(this.statusRecord == 'rejected') {
        this.call_auth_rejected?.click()
        return
      }
      // Xác nhận vì chuyển verified/reviewing sẽ ĐẨY Salesforce (verified: convert Lead→Opportunity, không undo phía SF; reviewing: tạo/đồng bộ Lead)
      if(this.statusRecord == 'verified' || this.statusRecord == 'reviewing') {
        const result = await Swal.fire({
          title: 'Xác nhận đẩy Salesforce',
          html: this.statusRecord == 'verified'
            ? 'Chuyển sang <b>Đã xác thực</b> sẽ <b>đẩy hồ sơ lên Salesforce</b> (convert Lead → Opportunity, không hoàn tác phía SF). Tiếp tục?'
            : 'Chuyển sang <b>Đang xem xét</b> sẽ <b>tạo / đồng bộ Lead trên Salesforce</b>. Tiếp tục?',
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: 'Đồng ý, đẩy SF',
          cancelButtonText: 'Hủy',
          customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-light me-3' },
        })
        if(!result.isConfirmed) {
          this.editingStatusId = null
          return
        }
      }
      this.callApiChangeStatus()
    },
    async callApiChangeStatus() {
      let data = {
        status: this.statusRecord
      }
      const isSfPush = this.statusRecord == 'verified' || this.statusRecord == 'reviewing'
      // BẤT ĐỒNG BỘ: đổi trạng thái NGAY trên UI, KHÔNG bắt user chờ ~5s đẩy Salesforce.
      // An toàn vì BE lưu trạng thái TRƯỚC rồi mới đẩy SF (comment cũ), và kết quả đẩy có
      // timeline + nút "Đồng bộ Salesforce" để đẩy lại nếu lỗi. Chỉ revert khi request HỎNG HẲN.
      const index = this.tableData.findIndex((item) => item.id == this.tempRecord.id)
      const _prevStatus = index > -1 ? this.tableData[index].status : null
      if (index > -1) {
        this.tableData[index].status = {
          label: this.statusTag[this.statusRecord]?.label,
          state: this.statusTag[this.statusRecord]?.state,
          value: this.statusRecord,
        }
      }
      this.editingStatusId = null
      // Không await-chặn UI: gửi rồi để chạy nền; chỉ xử lý lỗi SF (thông báo nhẹ) / lỗi cứng (revert).
      axios.put(`/admission/register/${this.tempRecord.id}`, data)
      .then(( {data} ) => {
        // BE trả _process { errors:[...] }. Đẩy SF KHÔNG throw, lỗi gom vào errors (trạng thái vẫn đã lưu).
        const sfErrors = (data && data.errors) || []
        if(isSfPush && sfErrors.length) {
          Swal.fire({
            title: 'Đã lưu trạng thái — nhưng ĐẨY SALESFORCE LỖI',
            html: `Cập nhật trạng thái <b>thành công</b>, nhưng <b>đẩy Salesforce thất bại</b>:<br>• ${sfErrors.join('<br>• ')}<br><br>Có thể bấm <b>"Đồng bộ Salesforce"</b> để thử đẩy lại.`,
            icon: 'warning',
            buttonsStyling: false,
            confirmButtonText: 'Đã hiểu',
            customClass: { confirmButton: 'btn btn-primary' },
          })
        }
        // Thành công (kể cả đẩy SF) -> KHÔNG popup: trạng thái đã đổi trên UI là đủ tín hiệu.
      })
      .catch(({ response }) => {
        // Lỗi cứng (lưu trạng thái thất bại) -> REVERT về trạng thái cũ để UI không sai lệch với DB
        if (index > -1 && _prevStatus) { this.tableData[index].status = _prevStatus }
        Swal.fire({
          title: 'Cập nhật thất bại',
          text: (response && response.data && (response.data.message || response.data.errorMessage)) || 'Có lỗi xảy ra, vui lòng thử lại.',
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Đã hiểu',
          customClass: { confirmButton: 'btn btn-primary' },
        })
      });
    },
    editAdmission(record) {
      // Chỉnh sửa = điều hướng NGAY TRANG NÀY sang "Thông tin chi tiết hồ sơ ứng viên"
      // (đã bỏ modal hoàn toàn — Thêm hồ sơ đi trang /themhoso/:idStudent, sửa đi trang này).
      // ?from=ungvien: để nút Đóng/Hủy bỏ ở trang hồ sơ quay lại tab "Hồ sơ đăng ký xét" của ứng viên.
      this.router.push({ path: `/hosoungvien/${record.id}`, query: { from: 'ungvien' } })
    },
    // Kebab > Đăng ký học bổng: mở modal chọn học bổng + ngành cho hồ sơ này
    async openScholarshipReg(record) {
      this.regSchRecord = record
      this.regSchId = null
      // Mặc định NV1: record.majors đã sort theo priority ở trang cha -> phần tử đầu là NV1
      this.regSchMajorId = (record?.majors && record.majors[0] && record.majors[0].id) || null
      this.regSchError = ''
      if (!this.scholarshipCatalog.length) {
        await axios.get(`/setting/scholarship`)
          // HB gắn cờ leaderonly chỉ trưởng nhóm/admin thấy khi đăng ký
          .then(({ data }) => { this.scholarshipCatalog = filterScholarshipOptions(data || []) })
          .catch(() => { this.scholarshipCatalog = [] })
      }
      ;(this.$refs.regSchTrigger as any)?.click()
    },
    async submitScholarshipReg() {
      if (!this.regSchId) {
        this.regSchError = 'Vui lòng chọn học bổng'
        return
      }
      if (!this.regSchMajorId) {
        this.regSchError = 'Vui lòng chọn ngành nhận học bổng'
        return
      }
      const sch = this.scholarshipCatalog.find((s: any) => s.id == this.regSchId)
      const major = (this.regSchRecord?.majors || []).find((m: any) => m.id == this.regSchMajorId)
      if (!sch || !this.regSchRecord) return
      this.regSchSaving = true
      // Payload tối thiểu theo model scholarship_registers (studentName NOT NULL) + ngành nhận HB (mặc định NV1)
      const tempData = {
        studentId: this.route.params.id,
        studentName: this.dataCustomer?.fullName || '',
        regScholarshipId: sch.id,
        regScholarshipCode: sch.code,
        regScholarshipName: sch.name,
        status: 'new',
        admissionRegisterId: this.regSchRecord.id,
        admissionRegisterCode: this.regSchRecord.code,
        majorId: major?.id,
        majorCode: major?.code,
        majorName: major?.name,
      }
      await axios.post(`/scholarshipregisters`, tempData)
        .then(() => {
          hideModal(this.$refs.regSchModalRef as any)
          Swal.fire({
            text: `Đã đăng ký ${sch.name} cho hồ sơ ${this.regSchRecord.code}. Xem/duyệt ở khối "Học bổng của ứng viên".`,
            icon: 'success', timer: 2500, timerProgressBar: true,
            buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
          })
          this.$emit('reload')
        })
        .catch(({ response }) => {
          // BE validator trả message tiếng Việt; gọt tiền tố kỹ thuật "Validation error: " do Sequelize bọc thêm
          const raw = response?.data?.errorMessage || response?.data?.message || ''
          this.regSchError = String(raw).replace(/^Validation error:\s*/i, '') || 'Đăng ký thất bại, vui lòng thử lại.'
        })
      this.regSchSaving = false
    },
    // Kebab > Xét trúng tuyển (hồ sơ ĐÃ XÁC THỰC): đi MỘT MẠCH tới TRÚNG TẠM chờ cấp QĐ
    // (POST /admission/appraised/passdirect): BE so điểm từng NV với ĐIỂM CHUẨN + SÀN trong Chỉ tiêu,
    // NV đầu tiên đạt -> thẩm định + tạo winner tạm. Cấp số QĐ ở trang "Kết quả xét tuyển sinh".
    appraiseProfile(record) {
      // Phòng thủ: hồ sơ liên thông không có bước thẩm định qua đây (id_ad_major null -> vỡ). Chặn ở handler luôn.
      if (record.idAdMethod == 9) { return }
      Swal.fire({
        title: 'Xét trúng tuyển',
        html: `Xét trúng tuyển hồ sơ <b>${record.code}</b> ngay?<br/>
          <span class="fs-7 text-gray-600">Hệ so điểm từng NV với <b>điểm chuẩn + điểm sàn</b> (Chỉ tiêu):
          NV đầu tiên đạt sẽ <b>TRÚNG TẠM — chờ cấp số QĐ</b> ở trang "Kết quả xét tuyển sinh".
          Hồ sơ sẽ bị khóa chỉnh sửa. Không NV nào đạt thì không thay đổi gì.</span>`,
        icon: 'question',
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: 'Xét trúng tuyển',
        cancelButtonText: 'Trở lại',
        customClass: { confirmButton: 'btn btn-primary order-2', cancelButton: 'btn btn-light order-1' },
      }).then(async (result) => {
        if (!result.isConfirmed) return
        await axios.post(`/admission/appraised/passdirect`, { id: record.id })
          .then(({ data }) => {
            Swal.fire({
              html: `Hồ sơ <b>TRÚNG TẠM</b> NV${data.nv} <b>${data.major}</b> (${data.adForm}) — điểm ${data.avg} / chuẩn ${data.benchmark}.<br/>
                <span class="fs-7 text-muted">Cấp số QĐ ở trang "Kết quả xét tuyển sinh" để thành trúng tuyển chính thức.</span>`,
              icon: 'success',
              buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
            })
            this.$emit('reload')
          })
          .catch(({ response }) => {
            Swal.fire({
              text: response?.data?.errorMessage || response?.data?.message || 'Thao tác thất bại.',
              icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
            })
          })
      })
    },
    async deleteCustomer(reason = undefined) {
      let isDelete = {
        isDelete: true,
        reason: reason,
        ids:[this.tempRecord.id]
      }
      await axios.put(`/admission/register/update/ids`,isDelete)
      .then(( {data} ) => {
        let index = this.tableData.findIndex(item => item.id == this.tempRecord.id)
        this.tableData.splice(index, 1);
      })
      .catch(({ response }) => {
        Swal.fire({
          text: (response && response.data && response.data.message) || 'Không thể xóa hồ sơ này.',
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Trở lại',
          customClass: { confirmButton: 'btn btn-primary' },
        })
      });
    },
  },
  async mounted() {
    
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();

    const addAuthRejectedModalRef = ref<null | HTMLElement>(null);
    const call_auth_rejected = ref<any>();
    const callFunctionModal = ref<any>();
    
    const comment_profile = ref('')
    const statusRecord = ref('')
    const statusTag =  ref(statusTagDefault)
    const arrResource = ref({
      "online": {
        label:"Trực tuyến",
        state: "success",
      },
      "office": {
        label:"Trực tiếp",
        state: "danger",
      },
      "postoffice": {
        label:"Bưu điện",
        state: "warning",
      },
      "email": {
        label:"Email",
        state: "primary",
      },
      "offline": {
        label:"Trực tiếp",
        state: "danger",
      },
      "gbetek": {
        label:"Đối tác GBE",
        state: "info",
      },
      "yoot": {
        label:"Đối tác Yoot",
        state: "info",
      },
    })
    const tableHeader = ref([
      {
        name: "MÃ HỒ SƠ",
        key: "code",
        sortable: true,
        class: "min-w-110px",
      },
      // {
      //   name: "ĐỢT",
      //   key: "phase",
      //   sortable: false,
      //   class: "phase",
      // },
      {
        name: "PT",
        key: "method",
        sortable: true,
      },
       {
        name: "NGÀNH",
        key: "majors",
        sortable: false,
      },
      
      {
        name: "Ngày tạo / Sửa",
        key: "date",
        sortable: false,
        class: "text-center text-nowrap",
      },
      {
        name: "NGUỒN",
        key: "source",
        sortable: false,
        class:"min-w-80px text-center"
      },
      {
        name: "TÌNH TRẠNG",
        key: "status",
        sortable: false,
        class: "text-center",
      },
      {
        name: "K.H",
        key: "isActive",
        sortable: false,
        class: "text-center",
      },
      {
        name: "",
        key: "actions",
        sortable: false,
        class: "text-center",
      },
    ]);
    const isAppraised = ref(false)
    const tableData = computed(() => {
      // let appraised = props.dataAdmission.filter((item:any) => item.isAppraised)
      // if(appraised.length != 0) {
      //   isAppraised.value = true
      // }
      return props.dataAdmission
    });
    const prScore = computed(() => {
      return props.priorityScore
    });
    const dataCustomer = computed(() => {
      return props.dataCustomer
    });
    function getCookie(name: string): string|null {
      const nameLenPlus = (name.length + 1);
      return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    }
    const activatedRegisterChange = async (isActive,record) => {
      //let index = -1
      let data = {
        isActive: isActive
      }
      await axios.put(`/admission/register/${record.id}`, data)
      .then(( {data} ) => {
        // console.log('data',data)
      })
      .catch(({ response }) => {
      });
    }

    function checkPermission(permission) {
      const value = permission
      const temp = window.localStorage.getItem("user")
      const user = temp?JSON.parse(temp) : undefined as any
      const listPermission = user?.permissions?.filter(item => item.name == value[1])

      if(listPermission && listPermission.length!=0) {
        const {permissions} = listPermission[0]
        if(permissions && permissions instanceof Array) {
          if (value && value instanceof Array) {
            if (value.length > 0) {
              const permissionRoles = [value[0]]
              const hasPermission = permissions.some(role => {
                return permissionRoles.includes(role)
              })
              return hasPermission //true | false
            }
          } else {
            return false
          }
        }
      }
      else {
        return false
      }
    };
    const formRef = ref<null | HTMLFormElement>(null);
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    return { 
      tableHeader,
      tableData,
      activatedRegisterChange,
      prScore,
      statusRecord,
      statusTag,
      getCookie,
      arrResource,
      Permission,
      checkPermission,
      isAppraised,
      addAuthRejectedModalRef,
      call_auth_rejected,
      comment_profile,
      user,
      callFunctionModal,
      router,
      route,
      dataCustomer
    };
  },
});
